import * as charts from "../../charts/";
import { ChartType } from "../../entities/reportEntity";

export default {
  id: 124,
  label: "代理机构技术分类分析",
  chart: charts.lineAndBar2D,
  definition: {
    rowDims: [{ name: "miniIpc", label: "主分类小类", limit: 10, needTotal: true }],
    colDims: [
      {
        name: "agencyName",
        label: "代理机构",
        limit: 10,
        needTotal: true,
      },
    ],
    measures: [{ name: "count", label: "专利量", sortBy: "DESC" }],
    showNoDataDims: true,
    condition: {
      items: [
        {
          name: "agencyName",
          operator: "NOT_NULL",
        },
      ],
    },
  },
  chartOption: {
    chartType: ChartType.BAR,
    title: "代理机构技术分类分析",
    subTitle: "",
    hideTitle: false,
    xaxisTitle: "",
    yaxisTitle: "",
    hideAxisTitle: true,
    hideLabel: true,
    hideLegend: false,
    hideToolbox: false,
  },
};
